import { AutopilotTaskDto } from '@urbanx/agx.activities.client';

export const sortTasksByCompletionThenOrder = (
  a: AutopilotTaskDto,
  b: AutopilotTaskDto
): number => {
  const aCompleted = Boolean(a.isCompleted);
  const bCompleted = Boolean(b.isCompleted);

  if (aCompleted !== bCompleted) return aCompleted ? 1 : -1;

  return (a.order ?? 0) - (b.order ?? 0);
};

export const sortTasksByCompletionThenDueDate = (
  a: AutopilotTaskDto,
  b: AutopilotTaskDto
): number => {
  const aCompleted = Boolean(a.isCompleted);
  const bCompleted = Boolean(b.isCompleted);

  if (aCompleted !== bCompleted) return aCompleted ? 1 : -1;

  const aDue = a.dueUtc ? new Date(a.dueUtc).getTime() : Infinity;
  const bDue = b.dueUtc ? new Date(b.dueUtc).getTime() : Infinity;

  if (aDue !== bDue) return aDue - bDue;

  const orderComparison = (a.order ?? 0) - (b.order ?? 0);

  return orderComparison;
};
